import React, { useEffect, useState } from "react";
import { Button, Nav, NavItem, NavLink } from "reactstrap";
import { NavLink as RRNavLink } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";
import avatar from "../../../assets/img/avatar.jpg";
import "./style.css";
import { getData } from "../../../api/method";

const username = localStorage.getItem("username");

function NavMenu() {
  const [data, setData] = useState({});

  const getUser = async () => {
    try {
      const result = await getData(`/api/User/${username}`);
      setData(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  const removeItem = () => {
    localStorage.removeItem("token_key");
    localStorage.removeItem("username");
    window.location.reload();
  };

  return (
    <div className="border_right py-3">
      <div className="info_admin fs-24 pb-4 pt-2 text-center">
        <div className="info_img">
          <img src={avatar} alt="img" width={100} height={100} />
        </div>

        <p className="mt-2 t-primary">{data.lastname} {data.firstname}</p>
      </div>

      <Nav vertical>
        <NavItem>
          <NavLink
            tag={RRNavLink}
            to="/admin/dashboard"
            className="fs-24 fw-bolder py-3 nav_link--admin px-5"
          >
            Dashboard
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            tag={RRNavLink}
            to="/admin/customers"
            className="fs-24 fw-bolder py-3 nav_link--admin px-5"
          >
            Customer
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            tag={RRNavLink}
            to="/admin/categories"
            className="fs-24 fw-bolder py-3 nav_link--admin px-5"
          >
            Category
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            tag={RRNavLink}
            to="/admin/brand"
            className="fs-24 fw-bolder py-3 nav_link--admin px-5"
          >
            Brand
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            tag={RRNavLink}
            to="/admin/product"
            className="fs-24 fw-bolder py-3 nav_link--admin px-5"
          >
            Product
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            tag={RRNavLink}
            to="/admin/order"
            className="fs-24 fw-bolder py-3 nav_link--admin px-5"
          >
            Order
          </NavLink>
        </NavItem>
      </Nav>

      <div className="btn--bottom">
        <Button
          className="btn_logout px-5 py-3 fs-24 fw-bolder d-flex align-items-center"
          onClick={() => removeItem()}
        >
          <FiLogOut className="me-2" />
          Log out
        </Button>
      </div>
    </div>
  );
}

export default NavMenu;
